<template>
  <main class="sa-content sa-lab-tecnician">
    <div class="sa-card-large">
      <div class="sa-mob-header">
        <h5 class="sa-card-tit">Lab Technician</h5>
        <button class="sa-btn-back" @click="$router.go(-1)">
          <i class="icon-arrow-left"></i>
        </button>
      </div>
      <LapTechnicianProfile />
      <template v-if="listData">
      <div class="sa-d-f-sbetween sa-mt30">
        <h6>Manage your Appointments</h6><span class="sa-link sa-see-all" @click="$router.push('/appointments')">See
          all</span>
      </div>
      <swiper class="swiper sa-mt15" ref="swiper" :options="swiperOption">
        <swiper-slide v-for="items in listData" :key="items.id">
          <AppointmentListCard :data="items"/>
        </swiper-slide>
      </swiper>
    </template>
      <div class="" v-else>
        <no-data-found />
      </div>
      <!-- <div class="sa-text-right"><button class="sa-btn sa-btn-primary sa-btn-block-md"
          @click="$router.push('/appointments')"> View all appointments </button></div> -->
    </div>
  </main>
</template>
<script>
import { lab_url, nurse_url } from "../../../config/endpoints";
import LapTechnicianProfile from "../../components/lab-technician/LapTechnicianProfile.vue";
import AppointmentListCard from "../../components/nurse/AppointmentListCard.vue";
import NoDataFound from "../../components/common/NoDataFound.vue";
export default {
  components: { LapTechnicianProfile, AppointmentListCard,NoDataFound },
  data() {
    return {
      listData:[],
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
          1024: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 1.8,
          },
          520: {
            slidesPerView: 1.3,
          },
          375: {
            slidesPerView: 1.1,
            spaceBetween: 10,
          },
          320: {
            slidesPerView: 1,
          },
        },
      },
    };
  },
  mounted() {
    this.aptList()
  },
  methods: {
    aptList() {
      this.utid = JSON.parse(this.$localStorage.get("utid"))
      this.api = this.utid === 4 ? `${lab_url}/appointment/list` : `${nurse_url}/appointment/list`
      let data = {
        limit: 2,
        page: 1,
        status: '3'
      };
      this.$store.dispatch("httpPost", { uri: this.api, body: data }).then(response => {
        if (response && response.status === 1000) {
          this.listData = response.data.data
         }
      })
    }
  },
};
</script>
